<script setup>
import { Head, useForm } from '@inertiajs/inertia-vue3';
import AuthenticationCardLogo from '@/Components/AuthenticationCardLogo.vue';
import InputError from '@/Components/InputError.vue';

import { ExclamationTriangleIcon } from '@heroicons/vue/20/solid'
import pickBy from "lodash/pickBy";
const props = defineProps({
    terms: String,
    latestversion: Number,
    date: String,
    user: Object,
    userLastAccepted: String,
    acceptedLatest: false,
    errors: Object,
});

const form = useForm({
    accepted: false,
    version: String
})

const acceptTerms = () =>{
    form.version = props.latestversion;
    form.put(route('terms.update'),{
        //preserveScroll:true,
    });
}

</script>

<template>
    <Head title="Terms of Service" />

    <div class="font-sans text-gray-900 antialiased">
        <div class="pt-4 bg-gray-100">
            <div class="min-h-screen flex flex-col items-center pt-6 sm:pt-0">
                <div>
                    <AuthenticationCardLogo /><br>
                </div>
                    <div class="rounded-md bg-yellow-50 p-4 mt-10" v-if="user && !acceptedLatest">
                        <div class="flex">
                            <div class="flex-shrink-0">
                                <ExclamationTriangleIcon class="h-5 w-5 text-yellow-400" aria-hidden="true" />
                            </div>
                            <div class="ml-3">
                                <h3 class="text-sm font-medium text-yellow-800">Attention needed</h3>
                                <div class="mt-2 text-sm text-yellow-700">
                                    <p>Our terms and conditions have changed! Please read and accept to continue using our platform and service.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                <div class="w-full sm:max-w-2xl mt-6 p-6 bg-white shadow-md overflow-hidden sm:rounded-lg prose" v-html="terms" />
                <InputError :message="form.errors.version" class="mt-2" />
                <InputError :message="form.errors.accepted" class="mt-2" />
                <div class="w-full sm:max-w-2xl mt-6 p-6 bg-white shadow-md overflow-hidden sm:rounded-lg prose mb-4" v-if="props.acceptedLatest">
                    Terms last updated: {{props.date}}<br>
                    You accepted these terms on: {{props.userLastAccepted}}
                </div>
                <fieldset v-if="user && !acceptedLatest">
                    <div class="space-y-5 w-full sm:max-w-2xl mt-6 p-6 bg-white shadow-md overflow-hidden sm:rounded-lg prose">
                        <div class="relative flex items-start">
                            <div class="flex h-6 items-center">
                                <input id="termsacceptance" aria-describedby="accept-terms" name="termsacceptance" type="checkbox" v-model="form.accepted" @change="acceptTerms" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                            </div>
                            <div class="ml-3 text-sm leading-6">
                                <label for="termsacceptance" class="font-medium text-gray-900">I accept the terms and conditions</label>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
</template>
